import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { sysLogin } from "@/api/api-basic";
import sha256 from "js-sha256";
import { State, Mutation } from "vuex-class";
import { getOprLogo } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
let PiLogin = class PiLogin extends Vue {
    constructor() {
        super(...arguments);
        this.test = "light";
        this.loading = false;
        this.logoPageInfo = {
            loginPageSlogan: "",
            oprSystemLogoUrl: null,
        };
        this.formInline = {
            userName: "",
            password: "",
            loginType: "0",
            subSystemPkId: "2",
            verCode: "",
            changeLang: "",
        };
        this.ruleInline = {
            userName: [
                {
                    required: true,
                    message: i18n.t("login.userNamePl"),
                    trigger: "blur",
                },
            ],
            password: [
                {
                    required: true,
                    message: i18n.t("login.passwordPl"),
                    trigger: "blur",
                },
                {
                    type: "string",
                    min: 6,
                    message: i18n.t("login.passwordMax"),
                    trigger: "blur",
                },
            ],
        };
        this.changeLangList = [
            {
                value: "zh-CN",
                label: "简体中文",
            },
            {
                value: "en-US",
                label: "English",
            },
        ];
    }
    changeLangFn(val) {
        this.$i18n.locale = val;
        sessionStorage.setItem("language", val);
        // location.reload();
    }
    handleSubmit() {
        const eleSub = this.$refs["formInline"] || {};
        eleSub.validate((valid) => {
            if (valid) {
                this.submitData();
            }
        });
    }
    /**
     * 登录
     */
    async submitData() {
        const json = JSON.parse(JSON.stringify(this.formInline));
        if (json.password.length < 20) {
            json.password = sha256.sha256(json.password);
        }
        this.loading = true;
        const ret = await sysLogin(json);
        if (ret.status == this["$config"].apiStatus) {
            let data = ret.data[0] || {};
            this.loginSuccess(data);
        }
        this.loading = false;
    }
    loginSuccess(data) {
        if (data.oprAuditStatus == 3 || data.oprAuditStatus == 4) {
            // 刚注册的账号，没写资料
            this["$common"].save("loginDataRegister", data);
            this.$router.push("/login/register").catch(() => {
                console.log("");
            });
        }
        else if (data.oprAuditStatus == 2) {
            // 写资料被拒绝
            this.$router
                .push("/login/register/register-account-wx-info")
                .catch(() => {
                console.log("");
            });
        }
        else {
            //
            this["$common"].save("loginData", data);
            this["$router"].push("/").catch(() => {
                console.log("");
            });
            if (data.expireRemindDate != null && data.expireRemindDate >= 0) {
                this["$Notice"].warning({
                    title: i18n.t("tips") + "",
                    desc: "账号将在" +
                        data.expireRemindDate +
                        "天后失效，失效后将无法登录系统",
                    duration: 15,
                });
            }
        }
    }
    async getOprLogo(oprPkId) {
        const ret = await getOprLogo({
            oprPkId: oprPkId,
        }, { noTips: true });
        if (ret.status === this.$config.apiStatus) {
            const data = ret.data[0];
            if (data.websiteRecordInfo) {
                this.SET_FOOTTEXT(data.websiteRecordInfo);
            }
            else {
                this.SET_FOOTTEXT(this.$config.footText);
            }
            if (data.loginPageSlogan) {
                this.logoPageInfo.loginPageSlogan = data.loginPageSlogan;
            }
            if (data.oprSystemLogoUrl) {
                this.logoPageInfo.oprSystemLogoUrl = data.oprSystemLogoUrl;
            }
            this.logoPageInfo.title = data.oprSystemName;
            const douc = document;
            douc.title = data.oprSystemName;
        }
    }
    /**
     * 注册账号
     */
    registerClick() {
        // this.$router.push("/login/register");
        this.$router.push("/login/register/account-register");
    }
    /**
     * 重置密码
     */
    passwordClick() {
        this.$router.push("/login/reset-password");
    }
    created() {
        const query = this.$route.query;
        if (query.userName && query.password) {
            this.formInline.userName = query.userName;
            this.formInline.password = query.password;
            this.$router.push({ query: {} });
            this.submitData();
        }
        else if (query.oprPkId && query.oprPkId > 0) {
            this.getOprLogo(query.oprPkId);
        }
        let loginDataRegister = this.$common.get("loginDataRegister");
        if (loginDataRegister) {
            this.$common.remove("loginDataRegister");
            location.reload();
        }
    }
    mounted() {
        // const _self = this;
        if (this.sys.isLogin) {
            this.SET_ISLOGIN(false);
            this["$common"].out();
        }
        document.onkeydown = (event) => {
            if (event.keyCode === 13 && !this.loading) {
                this.handleSubmit();
                return false;
            }
        };
        this.formInline.changeLang = this.$i18n.locale;
    }
    destroyed() {
        document.onkeydown = null;
    }
};
__decorate([
    State("sys")
], PiLogin.prototype, "sys", void 0);
__decorate([
    Mutation("SET_ISLOGIN")
], PiLogin.prototype, "SET_ISLOGIN", void 0);
__decorate([
    Mutation("SET_FOOTTEXT")
], PiLogin.prototype, "SET_FOOTTEXT", void 0);
PiLogin = __decorate([
    Component
], PiLogin);
export default PiLogin;
